import React from "react";

/**
 * Reusable table skeleton loader.
 * @param {number} rows - Number of skeleton rows
 * @param {number} cols - Number of columns
 * @param {boolean} showHeader - Whether to show header skeleton
 */
const TableSkeleton = ({ rows = 5, cols = 5, showHeader = true }) => (
  <div className="animate-pulse overflow-hidden rounded-lg">
    <table className="min-w-full divide-y divide-gray-200">
      {showHeader && (
        <thead className="bg-gray-100">
          <tr>
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i} className="px-6 py-4">
                <div className="h-4 bg-gray-200 rounded w-24" />
              </th>
            ))}
          </tr>
        </thead>
      )}
      <tbody className="bg-white divide-y divide-gray-200">
        {Array.from({ length: rows }).map((_, rowIdx) => (
          <tr key={rowIdx}>
            {Array.from({ length: cols }).map((_, colIdx) => (
              <td key={colIdx} className="px-6 py-4">
                <div
                  className={`h-4 bg-gray-100 rounded ${
                    colIdx === 0 ? "w-40" : colIdx === cols - 1 ? "w-16" : "w-24"
                  }`}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default TableSkeleton;
